import type { ReactNode } from 'react'

import { cn } from '../utilitarios/cn'

export interface PropriedadesCartao {
  children: ReactNode
  className?: string
  /** Remove o padding do corpo — para cartão que embrulha uma tabela. */
  semPadding?: boolean
}

export function Cartao({ children, className, semPadding }: PropriedadesCartao) {
  return (
    <section
      className={cn(
        'rounded-lg border border-borda bg-superficie shadow-sm',
        !semPadding && 'p-4 sm:p-5',
        className,
      )}
    >
      {children}
    </section>
  )
}

export function CabecalhoCartao({
  titulo,
  descricao,
  acoes,
  className,
}: {
  titulo: ReactNode
  descricao?: ReactNode
  acoes?: ReactNode
  className?: string
}) {
  return (
    <header
      className={cn(
        'flex flex-wrap items-start justify-between gap-3 border-b border-borda px-4 py-3 sm:px-5',
        className,
      )}
    >
      <div className="min-w-0">
        <h2 className="truncate text-sm font-semibold text-conteudo">{titulo}</h2>
        {descricao ? <p className="mt-0.5 text-xs text-conteudo-fraco">{descricao}</p> : null}
      </div>
      {acoes ? <div className="flex shrink-0 items-center gap-2">{acoes}</div> : null}
    </header>
  )
}

export function CorpoCartao({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('p-4 sm:p-5', className)}>{children}</div>
}

export function RodapeCartao({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <footer
      className={cn(
        'flex flex-wrap items-center justify-end gap-2 border-t border-borda bg-superficie-2 px-4 py-3 sm:px-5',
        className,
      )}
    >
      {children}
    </footer>
  )
}

/** Lista rótulo → valor. É o "Dados Pessoais" da TELA-05 e o resumo do lead. */
export function ListaDefinicao({
  itens,
  colunas = 1,
  className,
}: {
  itens: ReadonlyArray<{ rotulo: string; valor: ReactNode }>
  colunas?: 1 | 2 | 3
  className?: string
}) {
  return (
    <dl
      className={cn(
        'grid gap-x-6 gap-y-3 text-sm',
        colunas === 1 && 'grid-cols-1',
        colunas === 2 && 'grid-cols-1 sm:grid-cols-2',
        colunas === 3 && 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
        className,
      )}
    >
      {itens.map((item) => (
        <div key={item.rotulo} className="min-w-0">
          <dt className="text-xs font-medium uppercase tracking-wide text-conteudo-fraco">
            {item.rotulo}
          </dt>
          <dd className="mt-0.5 break-words text-conteudo">{item.valor}</dd>
        </div>
      ))}
    </dl>
  )
}
